export const FIELD_UNCONFIRMED_TYPE = 'FIELD_UNCONFIRMED';
export const ROW_UNCONFIRMED_TYPE = 'ROW_UNCONFIRMED';
export const LINE_MAY_BE_SWAPPED_TYPE = 'LINE_MAY_BE_SWAPPED';
export const LINE_ITEMS_MISSING_TYPE = 'LINE_ITEMS_MISSING';
export const LOCATION_UNMATCHED_TYPE = 'LOCATION_UNMATCHED';
export const DUPLICATE_PURCHASE_ORDER_TYPE = 'DUPLICATE_PURCHASE_ORDER';
export const DATE_OUTSIDE_WINDOW_TYPE = 'DATE_OUTSIDE_WINDOW';
export const LINE_POSITION_UNVERIFIED_TYPE = 'LINE_POSITION_UNVERIFIED';
export const DUPLICATE_LINE_ITEM_TYPE = 'DUPLICATE_LINE_ITEM';
export const LINE_ITEMS_TOTAL_MISMATCH_TYPE = 'LINE_ITEMS_TOTAL_MISMATCH';
export const LINE_ITEMS_UNCONFIRMED_TYPE = 'LINE_ITEMS_UNCONFIRMED';
